// // import React from 'react';
// // import { PieChart, Pie, Cell } from 'recharts';

// // const data = [
// //   { name: 'Active', value: 400, color: '#65c9ac' },
// //   { name: 'Draft', value: 300, color: '#72aeda' },
// //   { name: 'Archived', value: 300, color: '#bcbec4' }
// // ];

// // const outerData = [
// //   { name: 'Active', value: 400, color: '#65c9ac' },
// //   { name: 'Draft', value: 300, color: '#72aeda' },
// //   { name: 'Archived', value: 300, color: '#bcbec4' }
// // ];

// // const innerData = [
// //   { name: 'Active', value: 200, color: '#65c9ac' },
// //   { name: 'Draft', value: 0, color: '#72aeda' },
// //   { name: 'Archived', value: 0, color: '#bcbec4' }
// // ];

// // const RADIAN = Math.PI / 180;

// // const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
// //   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
// //   const x = cx + radius * Math.cos(-midAngle * RADIAN);
// //   const y = cy + radius * Math.sin(-midAngle * RADIAN);

// //   return (
// //     <text
// //       x={x}
// //       y={y}
// //       fill="white"
// //       textAnchor={x > cx ? 'start' : 'end'}
// //       dominantBaseline="central"
// //     >
// //       {`${(percent * 100).toFixed(0)}%`}
// //     </text>
// //   );
// // };

// // const ActivityGauge = () => {
// //   return (
// //     <PieChart width={400} height={400}>
// //       {/* Outer ring */}
// //       <Pie
// //         data={outerData}
// //         dataKey="value"
// //         cx={200}
// //         cy={200}
// //         innerRadius={100}
// //         outerRadius={150}
// //         fill="#8884d8"
// //         label={renderLabel}
// //       >
// //         {outerData.map((entry, index) => (
// //           <Cell key={`cell-${index}`} fill={entry.color} />
// //         ))}
// //       </Pie>

// //       {/* Inner ring */}
// //       <Pie
// //         data={innerData}
// //         dataKey="value"
// //         cx={200}
// //         cy={200}
// //         innerRadius={60}
// //         outerRadius={100}
// //         fill="#8884d8"
// //         label={renderLabel}
// //       >
// //         {innerData.map((entry, index) => (
// //           <Cell key={`cell-${index}`} fill={entry.color} />
// //         ))}
// //       </Pie>
// //     </PieChart>
// //   );
// // };

// // export default ActivityGauge;
// import React from "react";
// import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
// import "react-circular-progressbar/dist/styles.css";

// const ActivityGauge = () => {
//   const percentage = 50; // Set your desired percentage here
//   const text = "Average completion rate"; // Custom text you want to display

//   return (
//     <div
//       className="card-body mt-3.5 flex"
//       style={{ width: "30%", height: "400px", position: "relative" }}
//     >
//       <CircularProgressbar
//         value={percentage}
//         styles={buildStyles({
//           // textColor: "#4a90e2", // Change text color to match the image
//           pathColor: "#4a90e2", // Blue color for the progress
//           trailColor: "#d9d9d9", // Light grey for the remaining part
//           textSize: "24px", // Set font size for the text
//           pathTransitionDuration: 0.5, // Smooth animation
//         })}
//       />
//       <CircularProgressbar
//         className="second_svg"
//         value={percentage}
//         styles={buildStyles({
//           // textColor: "#4a90e2", // Change text color to match the image
//           pathColor: "#4a90e2", // Blue color for the progress
//           trailColor: "#d9d9d9", // Light grey for the remaining part
//           textSize: "24px", // Set font size for the text
//           pathTransitionDuration: 0.5, // Smooth animation
//         })}
//       />
//       <CircularProgressbar
//         className="third_svg"
//         value={percentage}
//         styles={buildStyles({
//           // textColor: "#4a90e2", // Change text color to match the image
//           pathColor: "#4a90e2", // Blue color for the progress
//           trailColor: "#d9d9d9", // Light grey for the remaining part
//           textSize: "24px", // Set font size for the text
//           pathTransitionDuration: 0.5, // Smooth animation
//         })}
//       />

//       {/* Centering the text in the middle of the progress circle */}
//       <div
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           textAlign: "center",
//           fontSize: "16px",
//           // color: '#4a90e2',
//         }}
//       >
//         Status
//         {/* <br />
//         <span
//           style={{ fontSize: "24px", fontWeight: "bold" }}
//         >{`${percentage}%`}</span> */}
//       </div>
//     </div>
//   );
// };

// export default ActivityGauge;

// import React from "react";
// import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
// import "react-circular-progressbar/dist/styles.css";

// const ActivityGauge = () => {
//   const chartData = {
//     active: 75,
//     draft: 50,
//     archived: 30,
//   };
//   const data = [
//     { label: "Active", value: chartData?.active || 0, color: "#6EC178" },
//     { label: "Draft", value: chartData?.draft || 0, color: "#4A90E2" },
//     { label: "Archived", value: chartData?.archived || 0, color: "#8C97A3" },
//   ];

//   return (
//     <div className="flex flex-col items-center">
//       <div style={{ position: "relative", width: "200px", height: "200px" }}>
//         {data.map((item, index) => (
//           <div
//             key={index}
//             style={{
//               position: "absolute",
//               width: "100%",
//               height: "100%",
//               top: 0,
//               left: 0,
//               transform: `scale(${1 - index * 0.15})`, // Adjusts size for stacking effect
//             }}
//           >
//             <CircularProgressbar
//               value={item.value}
//               maxValue={100}
//               strokeWidth={10}
//               styles={buildStyles({
//                 pathColor: item.color,
//                 trailColor: "#f0f0f0",
//                 strokeLinecap: "round",
//               })}
//             />
//           </div>
//         ))}

//         {/* Center Text */}
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             textAlign: "center",
//             fontSize: "16px",
//             fontWeight: "bold",
//           }}
//         >
//           Status
//         </div>
//       </div>

//       {/* Legend */}
//       <div className="mt-4 text-center">
//         {data.map((item, index) => (
//           <div key={index} className="flex items-center justify-center mb-2">
//             <span
//               style={{
//                 width: "10px",
//                 height: "10px",
//                 backgroundColor: item.color,
//                 borderRadius: "50%",
//                 display: "inline-block",
//                 marginRight: "8px",
//               }}
//             ></span>
//             <span>{item.label}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ActivityGauge;
import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ActivityGauge = ({ chartData }) => {
  const calculatePercentage = (count, total) => {
    return total > 0 ? ((count / total) * 100).toFixed(2) : 0;
  };
  const data = [
    {
      label: "Active",
      value:
        calculatePercentage(chartData?.activeIndCount, chartData?.totalCount) ||
        0,
      color: "#6EC178",
    },
    {
      label: "Draft",
      value:
        calculatePercentage(chartData?.draftIndCount, chartData?.totalCount) ||
        0,
      color: "#4A90E2",
    },
    {
      label: "Archived",
      value:
        calculatePercentage(
          chartData?.archivedIndCount,
          chartData?.totalCount
        ) || 0,
      color: "#8C97A3",
    },
  ];

  return (
    <div className="flex items-start gap-4">
      <div style={{ position: "relative", width: "250px", height: "250px" }}>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${1 - index * 0.20})`, // Adjust scale for spacing
              zIndex: data.length - index, // Ensures the top circle is rendered last
            }}
          >
            <CircularProgressbar
              value={item.value}
              maxValue={100}
              strokeWidth={8} // Controls thickness of the circles
              styles={buildStyles({
                pathColor: item.color,
                trailColor: "#f0f0f0",
                strokeLinecap: "round",
                rotation: 0.25, // Adds slight rotation for better alignment
              })}
            />
          </div>
        ))}

        {/* Center Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Status
        </div>
      </div>
      {/* Legend */}
      <div className="mt-4 text-center">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-start mb-2">
            <span
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: item.color,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "8px",
              }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityGauge;
